import SectionHeader from "./SectionHeader";

const rows = [
  {
    doubt: "「幕布」与「对照相」是否确为同一账号矩阵",
    note: "相似文案结构 + 发布时间线被并列举证，但缺乏账号后台等硬证据。",
    status: "待证",
    cls: "bg-secondary-100 text-secondary-900",
  },
  {
    doubt: "主角正面人设与实际行为是否存在系统性落差",
    note: "多组过往发言截图方向相反，构成「反差黑料」最核心的指控面。",
    status: "存疑",
    cls: "bg-accent-100 text-accent-900",
  },
  {
    doubt: "当事人 A 提供的聊天记录是否完整、有无裁剪",
    note: "记录原始性尚未被独立核验，关键缺口被多方反复追问。",
    status: "待证",
    cls: "bg-secondary-100 text-secondary-900",
  },
  {
    doubt: "关联账号归属口径，哪一方说法更能闭合时间线",
    note: "「对照相」澄清未附带佐证，与爆料方判断仍存冲突。",
    status: "矛盾",
    cls: "bg-primary-100 text-primary-800",
  },
  {
    doubt: "是否存在被误伤或张冠李戴的可能",
    note: "多人同名同 IP 现象被提及，身份指认的精确性仍是被反复讨论的软肋。",
    status: "存疑",
    cls: "bg-accent-100 text-accent-900",
  },
];

export default function DoubtCheck() {
  return (
    <section id="doubts" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <SectionHeader
          kicker="PART 03 · 疑点核查"
          title="身份疑点清单：哪些有说法，哪些仍待证"
          desc="把关于反差黑料人物身份的疑点逐条列出并标注当前状态。未实锤处一律标为待证，避免把猜测写成结论。"
        />

        <div className="rounded-xl border border-background-200 bg-background-100/60 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 bg-background-200/60 text-xs font-medium text-foreground-600">
            <div className="col-span-5">疑点</div>
            <div className="col-span-6">现状说明</div>
            <div className="col-span-1 text-right">状态</div>
          </div>
          {rows.map((r) => (
            <div
              key={r.doubt}
              className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 border-t border-background-200/80 items-start"
            >
              <div className="md:col-span-5 flex items-start gap-2">
                <i className="ri-question-line text-primary-500 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
                <h3 className="text-sm md:text-[15px] font-semibold text-foreground-900 leading-6">
                  {r.doubt}
                </h3>
              </div>
              <p className="md:col-span-6 text-sm leading-6 text-foreground-600">{r.note}</p>
              <div className="md:col-span-1 md:text-right">
                <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap ${r.cls}`}>
                  {r.status}
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-4 flex items-start gap-2 text-xs text-foreground-500 leading-6">
          <i className="ri-information-line text-primary-400 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
          状态口径：待证＝尚无独立材料支撑；存疑＝有多方说法但未收敛；矛盾＝现有口径彼此冲突，需等待更多证据。
        </p>
      </div>
    </section>
  );
}